export default "__VITE_ASSET__FGfLkEIM__"